export const MIXPANEL_RECORD_SESSION_PERCENT = 25;
